import { useState, useEffect, useContext, useRef } from "react";
import { AnimatePresence } from "framer-motion";
import { CartProvider } from "./components/CartContext";
import { UserContext } from "./context/UserContext";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
  useParams
} from "react-router-dom";
import AddressList from "./components/Address/AddressList";
import AgentPanel from './pages/MarsMart/AgentPanel';
import VerifyEmail from "./auth/VerifyEmail"; 
import VerificationModal from "./auth/VerificationModal"; 
import AuthContainer from "./auth/AuthContainer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CalltoAction from "./CalltoAction";
import IdeaValidationForm from "./IdeaValidationForms"; 
import MindMAppingForm from "./MindMapping/MindMAppingForm";
import Sidebar from "./Sidebar";
import Motive from "./Motive";
import AIDashboardChatbox from "./AIDashboardChatbox";
import CategoryCarouselNoSwiper from "./components/CategoryCarouselNoSwiper";
import Product from "./components/Product";
import Cart from "./components/Cart";
import PaymentPage from "./components/PaymentPage";
import Popup from "./components/Popup";
import GuestAuthPopup from "./components/GuestAuthPopup";
import RecoverPassword from './auth/RecoverPassword';
import OAuthPopupHandler from './auth/OAuthPopupHandler';
import Contact from "./Contact";
import ScoreCard from "./ScoreCard";
import OrdersPage from "./components/OrdersPage";
import TermsAndConditions from "./components/TermsandConditions";
import Report from "./IdeaValidationReport/Report"; // Updated path per new dev
import MobileHeader from "./components/MobileHeader";
import MobileChatFAB from "./components/MobileChatFAB";
import SingleProduct from "./components/SingleProduct";
import FundUtilizerForm from "./FundUtilizerForm";
import "./App.css";
import Home from "./Homepage/Homepage";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./components/NotFound";
import { ThemeContext } from "./context/themeContext";
import ReportB from "./Report-B/Report-B"; 
import PricingSection from "./ReportSubscriptionPage/PricingSection";
import TriplePaymentGateway from "./ReportSubscriptionPage/TriplePaymentGateway";
import ReportList from "./ReportSubscriptionPage/ReportList";
import ReportsHub from "./ReportsHub/ReportsHub";
import Tools from "./MindMapping/MindMapSecB";
import { AvatarProvider } from "./context/AvatarContext";
import ValidationBenefit from "./ValidationBenefit";
import MindMappingReportA from "./MindMapping/MindMappingReportA/MindMappingReportA";
import MindMappingReportB from "./MindMapping/MindMappingReportB/MindMappingReportB";
import MindMappingReportList from "./MindMapping/MindMappingReportList/index";
import MindMappingDashboard from "./MindMapping/MindMappingDashboard";
import MobileReportList from "./components/MobileReportList";
import OwnerDashboard from "./Owner/OwnerDashboard";
import OwnerLogin from "./Owner/OwnerLogin";
import OwnerSignup from "./Owner/OwnerSignup";
import OwnerVerifyEmail from "./Owner/OwnerVerifyEmail";
import AdminVerifyEmail from "./Admin/AdminVerifyEmail";
import AdminLogin from "./Admin/AdminLogin";
import AdminDashboard from "./Admin/AdminDashboard";
import ShareRedirect from "./components/ShareRedirect"; // <--- Add this
import SkillsMorePage from "./MindMapping/pages/SkillsMorePage";
import GoalsMorePage from "./MindMapping/pages/GoalsMorePage";
import SectorMorePage from "./MindMapping/pages/SectorMorePage";
import DistrictMorePage from "./MindMapping/pages/DistrictMorePage";
import ReadymadeTechs from "./MindMapping/pages/ReadymadeTechs";
import MarsMartStore from "./pages/MarsMart/MarsMartStore";
import MartAccess from "./pages/MarsMart/MartAccess";
import MMTracker from "./pages/MarsMart/MMTracker";
import MMFloatingCart from "./pages/MarsMart/MMFloatingCart";
import ReportInvoice from "./Invoice/ReportInvoice/ReportInvoice";
import ProductInvoice from "./Invoice/ProductsInvoice/ProductsInvoice";
import ConsultantInvoice from "./Invoice/ConsultantInvoice/ConsultantInvoice";
import OwnerPortal from "./pages/MarsMart/OwnerPortal/OwnerPortal";
import MarsMartHome from "./pages/MarsMart/MarsMartHome";
import MartOwnerLogin from "./pages/MarsMart/OwnerPortal/MartOwnerLogin";
import MartClientLogin from "./pages/MarsMart/MartClientLogin";
import MobileHandoff from "./pages/MarsMart/MobileHandoff";
import MMAiPage from "./pages/MMAi/MMAiPage";

export default function App() {
  const [activeTheme, setActiveTheme] = useState(() => {
    // v2 migration: reset old "dark" default to new "light" default once
    if (!localStorage.getItem("theme-v2-migrated")) {
      localStorage.removeItem("theme");
      localStorage.setItem("theme-v2-migrated", "1");
    }
    return localStorage.getItem("theme") || "light";
  });

  useEffect(() => {
    if (activeTheme === "dark") {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
    localStorage.setItem("theme", activeTheme);
  }, [activeTheme]);

  const handleThemeChange = (theme) => {
    setActiveTheme(theme);
  };

  return (
    <ThemeContext.Provider value={{ activeTheme, handleThemeChange }}>
      <CartProvider>
        <AvatarProvider>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </AvatarProvider>
      </CartProvider>
    </ThemeContext.Provider>
  );
}

// ... Guards ...
const ScoreCardGuard = ({setToggle,onClose}) => {
  const access = localStorage.getItem("scorecardAccess");
  const requiresPayment = JSON.parse(localStorage.getItem("scorecardData") || "{}").requiresPayment === true;
  if (access === "true" || requiresPayment) return <ScoreCard setToggle={setToggle} onClose={onClose}/>;
  return <Navigate to="/dashboard" replace />;
};
const ReportGuard = ({setToggle,onClose}) => {
  const access = localStorage.getItem("reportAccess");
  if (access === "true") return <Report setToggle={setToggle} onClose={onClose}/>;
  return <Navigate to="/dashboard" replace />;
};
const ReportBGuard = ({setToggle,onClose}) => {
  const access = localStorage.getItem("reportBAccess");
  if (access === "true") return <ReportB setToggle={setToggle} onClose={onClose}/>;
  return <Navigate to="/dashboard" replace />;
};
const MindMappindSecB = ({setToggle,onClose}) => {
  const access = localStorage.getItem("mind-mapping-access");
  if (access === "true") return <Tools setToggle={setToggle} onClose={onClose}/>; 
  return <Navigate to="/dashboard" replace />;
};

const getMarsMartCartCount = () => {
  try {
    const storedCart = JSON.parse(localStorage.getItem("mm-cart-items") || "[]");
    if (!Array.isArray(storedCart)) return 0;
    return storedCart.reduce(
      (total, item) => total + (Number(item?.quantity) || 0),
      0
    );
  } catch (error) {
    return 0;
  }
};

const MMTrackerRoute = () => {
  const { orderId } = useParams();
  return <MMTracker orderId={orderId} />;
};

function AppContent() {
  const { refreshUser, setUserType } = useContext(UserContext);
  const [toggle, setToggle] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { activeTheme } = useContext(ThemeContext);
  const [showMobProfile, setShowMobProfile] = useState(false);

  /* ── Guest auth popup ── */
  const [guestAuthOpen, setGuestAuthOpen] = useState(false);
  const pendingAuthCallback = useRef(null);
  const { user: authUser, loading: authLoading } = useContext(UserContext);
  const prevAuthUser = useRef(authUser);

  /* Listen for show-guest-auth events dispatched by any component */
  useEffect(() => {
    const handler = (e) => {
      pendingAuthCallback.current = e.detail?.callback || null;
      setGuestAuthOpen(true);
    };
    window.addEventListener("show-guest-auth", handler);
    return () => window.removeEventListener("show-guest-auth", handler);
  }, []);

  /* Fire the stored callback when user transitions null → logged-in */
  useEffect(() => {
    if (!prevAuthUser.current && authUser && pendingAuthCallback.current) {
      const cb = pendingAuthCallback.current;
      pendingAuthCallback.current = null;
      setGuestAuthOpen(false);
      cb();
    }
    prevAuthUser.current = authUser;
  }, [authUser]);

  /* Popup OAuth: if running inside a popup window, notify opener and close */
  useEffect(() => {
    if (authUser && window.opener) {
      try {
        window.opener.postMessage({ type: "GOOGLE_AUTH_SUCCESS" }, window.location.origin);
      } catch {}
      window.close();
    }
  }, [authUser]);

  const [googleConsentData, setGoogleConsentData] = useState(null);
  const [googleConsentChecked, setGoogleConsentChecked] = useState(false);
  const [googleConsentSubmitting, setGoogleConsentSubmitting] = useState(false);
  const [googleConsentError, setGoogleConsentError] = useState("");

  const handleGoogleConsentSubmit = async () => {
    if (!googleConsentChecked || !googleConsentData) return;
    setGoogleConsentSubmitting(true);
    setGoogleConsentError("");

    const url = googleConsentData.userType === "student"
      ? `${process.env.REACT_APP_BACKEND_URL}/student/google/confirm-signup`
      : `${process.env.REACT_APP_BACKEND_URL}/auth/google/confirm-signup`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: googleConsentData.name,
          email: googleConsentData.email,
          googleId: googleConsentData.googleId,
          profilePic: googleConsentData.profilePic,
          consent: true,
          policyVersion: "v1.0",
          termsVersion: "v1.0"
        }),
        credentials: "include"
      });

      const data = await response.json();
      if (response.ok) {
        if (googleConsentData.userType === "student") {
          setUserType("student");
          await refreshUser("student");
        } else {
          setUserType("client");
          await refreshUser("client");
        }
        localStorage.setItem("isLoggedIn", "true");
        window.dispatchEvent(new Event("auth-changed"));
        setGoogleConsentData(null);
        navigate("/dashboard", { replace: true });
      } else {
        setGoogleConsentError(data.message || "Registration failed");
      }
    } catch (err) {
      setGoogleConsentError("Something went wrong!");
    } finally {
      setGoogleConsentSubmitting(false);
    }
  };

      // Block right-click context menu everywhere (no popup, no menu)
      useEffect(() => {
        function handleContextMenu(e) {
          e.preventDefault();
        }

        function handleKeyDown(e) {
          // Block Ctrl+S, Ctrl+P, Ctrl+U (save, print, view source)
          if ((e.ctrlKey || e.metaKey) && ["s", "p", "u"].includes(e.key.toLowerCase())) {
            e.preventDefault();
          }
        }

        window.addEventListener("contextmenu", handleContextMenu, true);
        window.addEventListener("keydown", handleKeyDown, true);
        return () => {
          window.removeEventListener("contextmenu", handleContextMenu, true);
          window.removeEventListener("keydown", handleKeyDown, true);
        };
      }, []);

  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [authInitialMode, setAuthInitialMode] = useState("login");
  const [verificationToken, setVerificationToken] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const isMmAiRoute = location.pathname.startsWith("/mm-ai");
  const isMarsMartRoute = location.pathname.startsWith("/mars-mart");
  const [mmCartCount, setMmCartCount] = useState(() => getMarsMartCartCount());

  useEffect(() => {
    if (!isMarsMartRoute) return;
    setMmCartCount(getMarsMartCartCount());
  }, [isMarsMartRoute, location.pathname]);

  useEffect(() => {
    const handleMmCartUpdate = (event) => {
      const nextCount = Number(event?.detail?.count);
      if (Number.isFinite(nextCount)) {
        setMmCartCount(nextCount);
        return;
      }
      setMmCartCount(getMarsMartCartCount());
    };

    window.addEventListener("mm-cart-updated", handleMmCartUpdate);
    return () => window.removeEventListener("mm-cart-updated", handleMmCartUpdate);
  }, []);

  const isHomePage = location.pathname === "/landing";

  useEffect(() => {
    const pendingAction = localStorage.getItem("postAuthAction");
    if (pendingAction && location.pathname === "/dashboard") {
      localStorage.removeItem("postAuthAction");

      // Chatbot stores full target routes (e.g. /idea-validation/:t1/:t2).
      if (pendingAction.startsWith("/")) {
        // Avoid stale protected-route redirects overriding chatbot intent.
        sessionStorage.removeItem("postLoginRedirect");
        localStorage.removeItem("postLoginRedirect");
        navigate(pendingAction, { replace: true });
        return;
      }

      // Backward compatibility for older keyword-based actions.
      if (pendingAction === "ideaValidation") navigate("/dashboard", { replace: true });
      else if (pendingAction === "products") navigate("/dashboard", { replace: true });
      else if (pendingAction === "mind-mapping") navigate("/dashboard", { replace: true });
      else navigate("/dashboard", { replace: true });
      return;
    }

    const pendingProtectedRedirect =
      sessionStorage.getItem("postLoginRedirect") ||
      localStorage.getItem("postLoginRedirect");
    if (pendingProtectedRedirect) return;
  }, [location.pathname, navigate]);
  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const verifyToken = params.get("verifyToken");
    const openLogin = params.get("openLogin");
    const openSignup = params.get("openSignup");
    const authMode = params.get("authMode");
    const authError = params.get("authError");
    const authMessage = params.get("authMessage");
    const authUserType = params.get("authUserType");
    const googleConsentRequired = params.get("googleConsentRequired");

    let shouldCleanUrl = false;

    if (verifyToken) {
      setVerificationToken(verifyToken);
      shouldCleanUrl = true;
    }

    if (googleConsentRequired === "true") {
      setGoogleConsentData({
        email: params.get("email"),
        name: params.get("name"),
        googleId: params.get("googleId"),
        profilePic: params.get("profilePic"),
        userType: params.get("userType") || "client"
      });
      shouldCleanUrl = true;
    }

    const normalizedAuthMode = authMode === "signup" ? "signup" : "login";
    const normalizedUserType =
      authUserType === "student"
        ? "student"
        : authUserType === "client"
        ? "client"
        : null;
    const resolvedAuthMessage = authError || authMessage;

    if (resolvedAuthMessage) {
      const messageBaseKey =
        normalizedAuthMode === "signup"
          ? "oauthSignupMessage"
          : "oauthLoginMessage";
      const messageKey = normalizedUserType
        ? `${messageBaseKey}_${normalizedUserType}`
        : messageBaseKey;
      sessionStorage.setItem(messageKey, resolvedAuthMessage);
      shouldCleanUrl = true;
    }

    if (normalizedUserType) {
      sessionStorage.setItem("oauthAuthUserType", normalizedUserType);
      shouldCleanUrl = true;
    }

    // Only open auth modal when auth state is resolved AND user is not logged in
    const shouldOpenAuthModal =
      (openLogin || openSignup || resolvedAuthMessage || authMode) && !authLoading && !authUser;
    if (shouldOpenAuthModal) {
      const targetMode =
        openSignup || authMode === "signup" ? "signup" : "login";
      setAuthInitialMode(targetMode);
      setIsLoginOpen(true);
      shouldCleanUrl = true;
    }

    if (shouldCleanUrl) {
      window.history.replaceState({}, document.title, "/");
    }
  }, [location]);

  return (
    <>
      {(isHomePage || location.pathname === "/") && (
        <style>{`.total-visitors { display: none !important; }`}</style>
      )}

      { location.pathname !== "/admin" && location.pathname !== "/landing" && location.pathname !== "/404" && location.pathname !== "/pdf/consultant/invoice" && (
        <MobileHeader isOpen={mobileMenuOpen} onOpen={() => setMobileMenuOpen(true)} onClose={() => setMobileMenuOpen(false)} setShowMobProfile={setShowMobProfile}  showMobProfile={showMobProfile}/>
      )}

    <div className={`main ${location.pathname === "/landing" ? "home-main" : ""} ${activeTheme === "dark" ? "dark-mode" : ""} ${isMmAiRoute ? "mm-ai-active" : ""}`}>

        {location.pathname !== "/pdf/report-a-pdf" && 
         location.pathname !== "/pdf/invoice" && 
          location.pathname !== "/pdf/product/invoice" && 
         location.pathname !== "/pdf/consultant/invoice" && 
         location.pathname !== "/pdf/report-b-pdf" && 
         !location.pathname.includes("/admin") &&
         !location.pathname.includes("/Owner") &&
         !location.pathname.startsWith("/verify-email/") &&
         location.pathname !== "/pdf/mind-report-a-pdf" && 
         location.pathname !== "/pdf/mind-report-b-pdf" && 
         location.pathname !== "/landing" &&
         !location.pathname.startsWith("/report/:t1/:t2") &&
         !location.pathname.startsWith("/report-b/:t1/:t2") && 
         location.pathname !== "/404" && 
         !location.pathname.startsWith("/rcp/") && (
          <Sidebar toggle={toggle} setToggle={setToggle} />
        )}

        <div className={`main-content ${toggle ? "expanded" : ""}`}>
          <AnimatePresence mode="wait" initial={false}>
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/landing" element={<Home />} />
            <Route path="/about" element={<Navigate to="/landing" replace state={{ scrollTo: "about" }} />} />
            <Route path="/owner-portal" element={<OwnerPortal />} />
            <Route path="/admin/verify-handler/:token" element={<AdminVerifyEmail />} />
            <Route path={`/Owner/dashboard/${process.env.REACT_APP_OWNER_PATH}/en-list/owner`} element={<OwnerDashboard />} />
            <Route path={`/Owner/login/${process.env.REACT_APP_OWNER_PATH}/en-list/owner`} element={<OwnerLogin />} />
            <Route path="/Owner/verify-email/:token" element={<VerifyEmail />} />
            <Route path="/Owner/signup" element={<OwnerSignup />} />
            <Route path="/Owner/verify-handler/:token" element={<OwnerVerifyEmail />} />
            
            <Route path={`/Admin/dashboard/${process.env.REACT_APP_ADMIN_PATH}/en-list/admin`} element={<AdminDashboard />} />
            <Route path={`/Admin/login/${process.env.REACT_APP_ADMIN_PATH}/en-list/admin`} element={<AdminLogin />} />

            <Route path="/auth/popup-handler" element={<OAuthPopupHandler />} />
            <Route path="/privacy-policy" element={<TermsAndConditions />} />
            <Route path="/terms-conditions" element={<TermsAndConditions />} />
            <Route path="/rcp/:token" element={<RecoverPassword />} />
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            <Route
              path="/mm-ai"
              element={
                <ProtectedRoute>
                  <MMAiPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mm-ai/:t1/:t2"
              element={
                <ProtectedRoute>
                  <MMAiPage />
                </ProtectedRoute>
              }
            />
            <Route path="/mars-mart/access" element={<MartAccess />} />
            <Route path="/mars-mart/home" element={<MarsMartHome />} />
            <Route path="/mars-mart" element={<MarsMartStore />} />
            <Route path="/mars-mart/track/:orderId" element={<MMTrackerRoute />} />
            <Route path="/mars-mart/mobile-handoff" element={<MobileHandoff />} />
            <Route path="/mart-owner/login" element={<MartOwnerLogin />} />
            <Route path="/mart-client/login" element={<MartClientLogin />} />
            
            {/* ── PUBLIC: no login required to browse ── */}
            <Route path="/dashboard" element={<div className="dashboard-page"><Motive /><CalltoAction setToggle={setToggle} onClose={() => setMobileMenuOpen(false)} /><AIDashboardChatbox setToggle={setToggle} onClose={() => setMobileMenuOpen(false)} /><CategoryCarouselNoSwiper setToggle={setToggle} onClose={() => setMobileMenuOpen(false)} /></div>} />

            {/* ── PROTECTED: login required to view results ── */}
            <Route path="/scorecard/:t1/:t2" element={<ProtectedRoute><ScoreCardGuard setToggle={setToggle} onClose={() => setMobileMenuOpen(false)} /></ProtectedRoute>} />
            <Route path="/idea-validation/:t1/:t2" element={<IdeaValidationForm setToggle={setToggle} onClose={() => setMobileMenuOpen(false)} />} />
            <Route path="/mobile/reports/:t1/:t2" element={<MobileReportList setToggle={setToggle} onClose={() => setMobileMenuOpen(false)} />} />
            <Route path="/report/:t1/:t2" element={<ProtectedRoute><ReportGuard setToggle={setToggle} onClose={() => setMobileMenuOpen(false)} /></ProtectedRoute>} />
            <Route path="/report-b/:t1/:t2" element={<ProtectedRoute><ReportBGuard setToggle={setToggle} onClose={() => setMobileMenuOpen(false)} /></ProtectedRoute>} />
            <Route path="/pdf/report-b-pdf" element={<ReportB hideUI />} />
            <Route path="/pdf/report-a-pdf" element={<Report hideUI />} />
            <Route path="/pdf/mind-report-a-pdf" element={<MindMappingReportA hideUI />} />
            <Route path="/pdf/mind-report-b-pdf" element={<MindMappingReportB hideUI />} />
            <Route path="/pdf/invoice" element={<ReportInvoice  />} />
            <Route path="/pdf/product/invoice" element={<ProductInvoice  />} />
            <Route path="/mind-mapping/:t1/:t2" element={<MindMAppingForm setToggle={setToggle} onClose={() => setMobileMenuOpen(false)} />} />
            <Route path="/mind-mapping/sec-b/:t1/:t2" element={<MindMappindSecB setToggle={setToggle} onClose={() => setMobileMenuOpen(false)} />} />
            <Route path="/mind-mapping/sec-b/:t1/:t2/skills-more" element={<SkillsMorePage/>}/>
            <Route path="/mind-mapping/sec-b/:t1/:t2/goals-more" element={<GoalsMorePage/>}/>
            <Route path="/mind-mapping/sec-b/:t1/:t2/sector-more" element={<SectorMorePage/>}/>
            <Route path="/mind-mapping/sec-b/:t1/:t2/district-more" element={<DistrictMorePage/>}/>
            <Route path="/mind-mapping/sec-b/:t1/:t2/readymade-techs"element={<ReadymadeTechs />}/>

            <Route path="/validation-benefits/:t1/:t2" element={<ValidationBenefit onClose={() => setMobileMenuOpen(false)} />} />
            <Route path="/cart/:t1/:t2" element={<Cart setToggle={setToggle} onClose={() => setMobileMenuOpen(false)}/>} />
            <Route path="/product/:t1/:t2" element={<Product setToggle={setToggle} onClose={() => setMobileMenuOpen(false)} />} />
            <Route path="/business-product/:t1/:t2/:t3" element={<SingleProduct setToggle={setToggle} onClose={() => setMobileMenuOpen(false)}/>} />
            <Route path="/orders/:t1/:t2" element={<ProtectedRoute><OrdersPage setToggle={setToggle} onClose={() => setMobileMenuOpen(false)}/></ProtectedRoute>} />
            <Route path="/reports/:t1/:t2" element={<ReportList setToggle={setToggle} onClose={() => setMobileMenuOpen(false)}/>}/>
            <Route path="/reports-hub/:t1/:t2" element={<ReportsHub setToggle={setToggle} onClose={() => setMobileMenuOpen(false)} />}/>
            <Route path="/mind-mapping/dashboard/:t1/:t2" element={<MindMappingDashboard setToggle={setToggle} onClose={() => setMobileMenuOpen(false)} />}/>
            <Route path="/mind-mapping/reports/:t1/:t2" element={<MindMappingReportList setToggle={setToggle} onClose={() => setMobileMenuOpen(false)}/>}/>
            <Route path='/mind-mapping-report-a/:t1/:t2' element={<MindMappingReportA toggle={toggle} setToggle={setToggle} onClose={() => setMobileMenuOpen(false)}/>} />
            <Route path='/mind-mapping-report-b/:t1/:t2' element={<MindMappingReportB toggle={toggle} setToggle={setToggle} onClose={() => setMobileMenuOpen(false)}/>} />
            <Route path="/report-subscription/:t1/:t2" element={<PricingSection setToggle={setToggle} onClose={() => setMobileMenuOpen(false)}/>} />
            <Route path="/triple-payment/:t1/:t2" element={<ProtectedRoute><TriplePaymentGateway setToggle={setToggle} onClose={() => setMobileMenuOpen(false)}/></ProtectedRoute>} />
            <Route path="/payment/:t1/:t2" element={<ProtectedRoute><PaymentPage setToggle={setToggle} onClose={() => setMobileMenuOpen(false)}/></ProtectedRoute>} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/fund-utilizer" element={<ProtectedRoute><FundUtilizerForm /></ProtectedRoute>} />
           <Route path="/share/:slugId" element={<ShareRedirect />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="/delivery/agent" element={<AgentPanel />} />
            <Route path="*" element={<Navigate to="/404" replace />} />


            <Route
  path="/pdf/consultant/invoice"
  element={<ConsultantInvoice />}
/>
        <Route 
  path="/profile/addresses/:t1/:t2" 
  element={
    <ProtectedRoute>
       <div style={{ paddingTop: "80px" }}> 
          <AddressList /> 
       </div>
    </ProtectedRoute>
  } 
/>
            
          </Routes>
          <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} closeOnClick pauseOnHover draggable />
          <Popup />
          </AnimatePresence>
        </div>
      </div>

      {isMarsMartRoute && mmCartCount > 0 && (
        <MMFloatingCart
          itemCount={mmCartCount}
          onClick={() => window.dispatchEvent(new Event("mm-open-cart"))}
        />
      )}
      
{location.pathname === "/dashboard" && (
  <MobileChatFAB />
)}


      {verificationToken && (
        <VerificationModal token={verificationToken} onClose={() => setVerificationToken(null)} onVerified={() => { setVerificationToken(null); setAuthInitialMode("login"); setIsLoginOpen(true); }} />
      )}

      {isLoginOpen && !authUser && (
        <AuthContainer
          isOpen={isLoginOpen}
          onClose={() => setIsLoginOpen(false)}
          initialMode={authInitialMode}
        />
      )}

      {/* ── Guest auth popup (bottom-right, only shown when user is NOT logged in) ── */}
      {!authUser && (
        <GuestAuthPopup
          isOpen={guestAuthOpen}
          onClose={() => { setGuestAuthOpen(false); pendingAuthCallback.current = null; }}
          onOpenEmailAuth={() => {
            setAuthInitialMode("login");
            setIsLoginOpen(true);
          }}
        />
      )}

      {googleConsentData && (
        <div className="google-consent-modal-overlay">
          <div className="google-consent-modal-box">
            <h3 className="google-consent-title">Consent Required</h3>
            <p className="google-consent-msg">
              Hi <strong>{googleConsentData.name}</strong>, to complete your registration using Google, please review and agree to our policies.
            </p>
            <div className="google-consent-checkbox-group">
              <input
                type="checkbox"
                id="google-consent-checkbox"
                checked={googleConsentChecked}
                onChange={(e) => setGoogleConsentChecked(e.target.checked)}
              />
              <label htmlFor="google-consent-checkbox">
                I agree to the <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="/terms-conditions" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
              </label>
            </div>
            {googleConsentError && <p className="google-consent-error">{googleConsentError}</p>}
            <div className="google-consent-buttons">
              <button
                className="google-consent-btn-confirm"
                disabled={googleConsentSubmitting || !googleConsentChecked}
                onClick={handleGoogleConsentSubmit}
              >
                {googleConsentSubmitting ? "Completing Registration..." : "Complete Registration"}
              </button>
              <button
                className="google-consent-btn-cancel"
                disabled={googleConsentSubmitting}
                onClick={() => setGoogleConsentData(null)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
